import { render, staticRenderFns } from "./addPartner.vue?vue&type=template&id=21dbcbb2&scoped=true&"
import script from "./addPartner.vue?vue&type=script&lang=js&"
export * from "./addPartner.vue?vue&type=script&lang=js&"
import style0 from "./addPartner.vue?vue&type=style&index=0&id=21dbcbb2&prod&lang=scss&"
import style1 from "./addPartner.vue?vue&type=style&index=1&id=21dbcbb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dbcbb2",
  null
  
)

export default component.exports